import callApiAxiosClient from '../../axios/axios_client';

export type ExternalLink = {
    page: string;
    link: string;
    id: number;
    tenant_id: number;
}

async function getExternalLink(page: string): Promise<ExternalLink> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = `Bearer ${token.token}`;

  return callApiAxiosClient<ExternalLink>({
    method: 'get',
    url: 'programmability/external-link',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    params: {
      page: page
    },
  });
}

export default getExternalLink;
